import { Skeleton, Stack, styled } from '@mui/material'

export const MosaicLayoutSkeleton = () => {
  return (
    <StyledContainer>
      <StyledStack>
        <Skeleton variant="rectangular" animation="wave" width={64} height={64} sx={{ borderRadius: '8px' }} />
        <Skeleton variant="text" animation="wave" width={280} height={30} sx={{ marginTop: '20px', borderRadius: '4px' }} />
        <Skeleton variant="text" animation="wave" width={520} height={20} sx={{ marginTop: '8px', borderRadius: '4px' }} />
        <Skeleton variant="text" animation="wave" width={520} height={20} sx={{ borderRadius: '4px' }} />
      </StyledStack>
    </StyledContainer>
  )
}

const StyledStack = styled(Stack)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  margin-bottom: 16rem;
`

const StyledContainer = styled('div')`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 4rem);
    width: calc(100% - 1rem);
    border-radius: 0.5rem;
    border: 1px dashed #D8D8D8;
    margin: 0.5rem 0 0.5rem 0.5rem;
`